import React from 'react';
import { connect } from 'react-redux'
import styles from './assets/styles/main.css';

import BackgroundText from './BackgroundText';
import CartTable from './CartTable';

const Cart = () => {
		return (

			<div id = "cart">
				<BackgroundText text = {'React Ecommerce Store'} />
				<div className = "container">
					<CartTable />
				</div>
			</div>

		)
}

export default Cart;